import { Camera, Droplets, Flame } from 'lucide-react'

export default function Nutrition() {
  return (
    <div className="p-4 md:p-6 max-w-4xl mx-auto space-y-6">
      <div className="flex items-center justify-between">
        <div>
          <h1 className="text-2xl font-semibold">Харчування</h1>
          <p className="text-slate-400 text-sm mt-0.5">Калорії, макроси та вода</p>
        </div>
        <button className="btn-primary flex items-center gap-2">
          <Camera size={18} />
          Розпізнати їжу
        </button>
      </div>

      <div className="grid sm:grid-cols-3 gap-4">
        <div className="card p-5">
          <div className="flex items-center gap-2 text-sm text-slate-400 mb-1">
            <Flame size={16} className="text-orange-400" />
            Калорії
          </div>
          <div className="text-2xl font-semibold">1 650 / 2 200</div>
          <div className="text-xs text-slate-500 mt-1">Залишилось 550 ккал</div>
          <div className="mt-3 h-2 bg-slate-800 rounded-full overflow-hidden">
            <div className="h-full bg-orange-500 rounded-full" style={{ width: '75%' }} />
          </div>
        </div>
        <div className="card p-5">
          <div className="flex items-center gap-2 text-sm text-slate-400 mb-1">
            <Droplets size={16} className="text-cyan-400" />
            Вода
          </div>
          <div className="text-2xl font-semibold">1.4 / 2 л</div>
          <div className="text-xs text-slate-500 mt-1">70% від норми</div>
          <div className="mt-3 h-2 bg-slate-800 rounded-full overflow-hidden">
            <div className="h-full bg-cyan-500 rounded-full" style={{ width: '70%' }} />
          </div>
        </div>
        <div className="card p-5">
          <div className="text-sm text-slate-400 mb-3">Макроси</div>
          <div className="space-y-2 text-sm">
            <div className="flex justify-between">
              <span className="text-violet-400">Білки</span>
              <span>98 г</span>
            </div>
            <div className="flex justify-between">
              <span className="text-emerald-400">Жири</span>
              <span>56 г</span>
            </div>
            <div className="flex justify-between">
              <span className="text-sky-400">Вуглеводи</span>
              <span>175 г</span>
            </div>
          </div>
        </div>
      </div>

      <div className="card p-5">
        <h2 className="font-medium mb-4">Сьогоднішні прийоми їжі</h2>
        <div className="space-y-3">
          {[
            { name: 'Куряче філе з овочами', cal: 550, time: '09:15', p: 45, f: 16, c: 58 },
            { name: 'Кава та десерт', cal: 280, time: '10:42', p: 5, f: 12, c: 38 },
          ].map((meal) => (
            <div key={meal.name} className="flex items-center gap-4 p-3 rounded-xl bg-slate-800/40">
              <div className="w-12 h-12 rounded-xl bg-slate-700 flex items-center justify-center text-xl">
                🍽
              </div>
              <div className="flex-1">
                <div className="font-medium text-sm">{meal.name}</div>
                <div className="text-xs text-slate-500 mt-0.5">
                  Б {meal.p}г · Ж {meal.f}г · В {meal.c}г
                </div>
              </div>
              <div className="text-right">
                <div className="font-medium">{meal.cal} ккал</div>
                <div className="text-xs text-slate-500">{meal.time}</div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}
